import request from '@/utils/request'


// 查询课程目录列表
export function listCatalogue(query) {
  return request({
    url: '/catalogue/catalogue/list',
    method: 'get',
    params: query
  })
}

// 查询课程目录分页
export function pageCatalogue(query) {
  return request({
    url: '/catalogue/catalogue/page',
    method: 'get',
    params: query
  })
}

// 查询课程目录详细
export function getCatalogue(data) {
  return request({
    url: '/catalogue/catalogue/detail',
    method: 'get',
    params: data
  })
}

// 新增课程目录
export function addCatalogue(data) {
  return request({
    url: '/catalogue/catalogue/add',
    method: 'post',
    data: data
  })
}

// 修改课程目录
export function updateCatalogue(data) {
  return request({
    url: '/catalogue/catalogue/edit',
    method: 'post',
    data: data
  })
}

// 删除课程目录
export function delCatalogue(data) {
  return request({
    url: '/catalogue/catalogue/delete',
    method: 'post',
    data: data
  })
}

// 获取课程名称
export function courseName() {
  return request({
    url: '/catalogue/catalogue/courseName',
    method: 'get',
  })

}
